/*
 * @Autor: lh
 * @Date: 2022-05-28 10:33:45
 * @LastEditors: lh
 * @LastEditTime: 2022-06-11 14:05:00
 * @Description: 
 */
/**
 * Created by Admin on 2019/2/12.
 */
import md5 from 'js-md5'
import {systemFn} from "./common.js"

export default {
  install(Vue,options){
    Vue.prototype.config = {
      // 获取当前渠道 1:安卓 2:ios 3:网页 5:网页
      system: systemFn(),
      channel: 1,//渠道ID
      onWeiXin : (function() {
          var u = navigator.userAgent;
          var onWeiXin = u.indexOf("MicroMessenger") > -1
          return onWeiXin;
        })(),

      key: '14e1b600b1fd579f47433b88e8d85291'//ClientKey在sdk后台研发游戏管理游戏盒子中获取
    },
    Vue.prototype.util = {
      // 对象拼接成url
      jointUrl(data){
        var params = '';
        for(var key in data){
          params += key + '=' + data[key] + '&';
        }
        params = params.replace(/&{1}$/,'');
        return params;
      },
      // 获取签名 sign
      getSign(options, appkey){
        const key = appkey || Vue.prototype.config.key;
        return md5(Vue.prototype.util.jointUrl(options) + key).toLowerCase();
      },
      /**
       * 时间戳转换成时间格式
       * @params {number} 参数nows(必传) 需要转换的时间戳 
       * @params {string} 参数type(非比传) 需要成什么样的时间格式 s:年月日-时分秒 m:年月日-时分 h:m:年月日-时分
       * */ 
      formatTime: function(nows, type) {
        if(nows.length === 10){
          nows = nows * 1000
        }
        var now = new Date(nows);
        var year=now.getFullYear();
        var month=now.getMonth()+1;
        if(month < 10) {
          month = '0' + month;
        }
        var date=now.getDate();
        if(date < 10) {
          date = '0' + date;
        }
        var hour=now.getHours();
        if(hour < 10) {
          hour = '0' + hour;
        }
        var minute=now.getMinutes();
        if(minute < 10) {
          minute = '0' + minute;
        }
        var second = now.getSeconds();
        if(second < 10) {
          second = '0' + second;
        }
        if(type){
          if(type === 's'){
            return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
          } else if(type === 'm'){
            return year+"-"+month+"-"+date+" "+hour+":"+minute;
          } else if(type === 'h'){
            return year+"-"+month+"-"+date+" "+hour;
          } else if(type === 'D'){
            return year+"-"+month+"-"+date;
          } else if(type === 'M'){
            return year+"-"+month;
          }
        } else {
          return year+"-"+month+"-"+date+" "+hour+":"+minute;
        }
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/static/js/public.js



// WEBPACK FOOTER //
// ./src/static/js/public.js